import {baseFetch, injectCacheTags} from './base';
import {resolveAPIRoute} from '@/lib/routes';
import type {KYCGift} from '@/types/api/customer-loyalty-program';

export enum CustomerLoyaltyProgramRoutes {
  CustomerLoyaltyProgram = 'base.customer-loyalty-program',
  KYCGift = 'base.customer-loyalty-program.kyc-gift'
}

export async function getKYCGift(requestArgs?: RequestInit) {
  return (
    await baseFetch(
      resolveAPIRoute(CustomerLoyaltyProgramRoutes.KYCGift),
      injectCacheTags(
        [
          CustomerLoyaltyProgramRoutes.CustomerLoyaltyProgram,
          CustomerLoyaltyProgramRoutes.KYCGift
        ],
        requestArgs
      )
    )
  ).data as KYCGift | null;
}

export async function requestKYCGift(requestArgs?: RequestInit) {
  return (
    await baseFetch(
      resolveAPIRoute(CustomerLoyaltyProgramRoutes.KYCGift),
      injectCacheTags(
        [
          CustomerLoyaltyProgramRoutes.CustomerLoyaltyProgram,
          CustomerLoyaltyProgramRoutes.KYCGift
        ],
        {
          method: 'POST',
          ...requestArgs
        }
      )
    )
  ).data as KYCGift;
}
